export enum GuestReceiptTextSize {
  Small = 'small',
  Medium = 'medium',
  Large = 'large',
}
